export enum LimitsPageId {
  Limits = 'limits',
  SelfExclusion = 'self-exclusion',
}
